import { render, staticRenderFns } from "./HeaderCompanies.vue?vue&type=template&id=0d944183&"
import script from "./HeaderCompanies.vue?vue&type=script&lang=js&"
export * from "./HeaderCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports